import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../../shared/elements";

export const ProfileRow = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;
`;

export const AvatarWrapper = styled.div`
	flex-shrink: 0;
`;

export const ProfileDetails = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	flex: 1;
`;

export const Username = styled.span`
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 16px;
	font-weight: 600;
	line-height: 1.3;
`;

export const UserMeta = styled.span`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.4;
`;

export const UserIdRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const CopyLink = styled.button`
	padding: 0;
	border: none;
	background: transparent;
	color: ${BTTO_PROFILE_COLORS.primary};
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;

	&:hover {
		opacity: 0.85;
	}
`;

export const ContactField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	& + & {
		margin-top: 16px;
	}
`;

export const FieldLabel = styled.label`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
`;

export const FieldInputRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`;

export const FieldInput = styled.input`
	flex: 1;
	min-width: 0;
	height: 44px;
	padding: 0 14px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;

	&:disabled {
		opacity: 1;
		cursor: default;
	}
`;

export const PhoneHint = styled.span`
	flex: 1;
	min-width: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 13px;
	line-height: 1.4;
`;

export const EditFormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 8px;

	.ant-form-item {
		margin-bottom: 12px;
	}

	.ant-input {
		height: 44px !important;
		border-radius: 8px !important;
		border: 1px solid ${BTTO_PROFILE_COLORS.border} !important;
		background: ${BTTO_PROFILE_COLORS.surfaceRaised} !important;
		color: ${BTTO_PROFILE_COLORS.text} !important;
	}

	.ant-btn-primary {
		height: 40px;
		border-radius: 8px;
		background: ${BTTO_PROFILE_COLORS.primary} !important;
		border: none !important;
		color: ${BTTO_PROFILE_COLORS.primaryText} !important;
		font-weight: 600;
	}
`;

export const CardHeaderRow = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
`;
